import { useEffect } from 'react';
import { setExtra, setUser } from '@sentry/remix';
import { useConvex, useQuery } from 'convex/react';
import { useConvexSessionIdOrNullOrLoading, getConvexAuthToken } from '~/lib/stores/sessionId';
import { useChatId } from '~/lib/stores/chatId';
import { setProfile } from '~/lib/stores/profile';
import { getConvexProfile } from '~/lib/convexProfile';
import { useLDClient, withLDProvider, basicLogger } from 'launchdarkly-react-client-sdk';
import { api } from '@convex/_generated/api';

export const UserProvider = withLDProvider<any>({
  clientSideID: import.meta.env.VITE_LD_CLIENT_SIDE_ID,
  options: {
    logger: basicLogger({ level: 'error' }),
  },
})(UserProviderInner);

function UserProviderInner({ children }: { children: React.ReactNode }) {
  const launchdarkly = useLDClient();
  // const { user } = useAuth();
  const convexMemberId = useQuery(api.sessions.convexMemberId);
  const sessionId = useConvexSessionIdOrNullOrLoading();
  const chatId = useChatId();
  const convex = useConvex();

  useEffect(() => {
    if (sessionId) {
      setExtra('sessionId', sessionId);
    }
  }, [sessionId]);

  useEffect(() => {
    setExtra('chatId', chatId);
  }, [chatId]);

  const tokenValue = (convex as any)?.sync?.state?.auth?.value;

  const profile = useQuery(api.sessions.getProfile);

  useEffect(() => {
    if (profile !== undefined) {
      setProfile(profile || null);
    }
  }, [profile]);

  useEffect(() => {
    async function updateProfile() {
      if (launchdarkly && convexMemberId) {
        launchdarkly?.identify({
          key: convexMemberId ?? '',
        });
      }

      const token = getConvexAuthToken(convex);

      if (profile === null && token) {
        try {
          await convex.action(api.sessions.updateCachedProfile, {
            convexAuthToken: token,
          });
        } catch (e) {
          console.error('Failed to update cached profile', e);
        }
      }
    }
    void updateProfile();
  }, [launchdarkly, convexMemberId, profile, convex]);

  return children;
}
